<template>
    <v-dialog v-model="shows" width="560" content-class="ma-0 pa-0">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card class="ma-0 pa-0">
            <v-card-title class="pa-16">
                <v-text-field outlined placeholder="이름 또는 아이디를 입력해주세요.">
                    <template #append-outer>
                        <v-btn color="priamry">검색하기</v-btn>
                    </template>
                </v-text-field>
            </v-card-title>
            <div class="px-16 pt-0 pb-16">
                이름 검색은 내 공공에 지원한 사용자나 인력풀에서만 검색됩니다.<br />
                내 정보에 없는 사용자 선택시 이름 또는 전화번호, 이메일을 정확이 입력해야합니다.
            </div>
            <div class="px-16 pt-0 pb-16">
                <v-row class="ma-0">
                    <template v-for="item in items">
                        <v-col cols="12" class="pa-8" :key="item._id">
                            <room-participants-push-item v-bind="{ item, selected }" />
                        </v-col>
                    </template>
                </v-row>
            </div>
            <div class="px-16 pt-0 pb-16">
                <v-row class="ma-n8">
                    <v-col class="pa-8">
                        <v-btn block @click="close"> 취소하기 </v-btn>
                    </v-col>
                    <v-col class="pa-8">
                        <v-btn block @click="push"> 추가하기 </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import RoomParticipantsPushItem from "./room-participants-push-item.vue";
import { mapState } from "vuex";
export default {
    components: {
        RoomParticipantsPushItem,
    },
    data: () => ({
        shows: false,
        selected: [],
    }),
    computed: {
        ...mapState("interview", { interview: (store) => store.data }),
        items() {
            return [];
        },
        _extraviewees() {
            return this.selected.map(({ _id }) => _id);
        },
    },
    methods: {
        init() {
            this.selected = [];
        },
        toggle(user) {
            let index = this.selected.findIndex((item) => item == user);
            if (-1 < index) this.selected.splice(index, 1);
            else this.selected.push(user);
        },
        close() {
            this.shows = false;
            this.selected = [];
        },
        async push() {
            this.$store.commit("interview/setLoading", true);
            try {
                const { _extraviewees } = this;
                const { _id: _interview, code } = this.interview;
                await api.v1.company.interviews.extraviewees.post({ _interview, _extraviewees });

                const { interview } = await api.v1.interview.get({ code });
                this.$store.commit("interview/setData", { data: interview });

                alert("성공적으로 추가되었습니다");
            } finally {
                this.$store.commit("interview/setLoading", false);
            }
        },
    },
    watch: {
        shows() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style>
</style>